import PERFIL from '@/constants/perfil'

// LISTAGENS
import ListagemInformacao from '@/screens/central/cadastros/para/solicitarInformacao/Home'
import ListagemAforamento from '@/screens/central/cadastros/para/resgateAforamento/Home'
import ListagemPermuta from '@/screens/central/cadastros/para/permuta/Home'
import ListagemTransferenciaDireito from '@/screens/central/cadastros/para/transferenciaDireito/Home'
import ListagemAreasPatrimoniais from '@/screens/central/cadastros/para/areasPatrimoniais/Home'

// CADASTROS
import SolicitarInformacao from '@/screens/central/cadastros/para/solicitarInformacao/Cadastro'
import AreasPatrimoniais from '@/screens/central/cadastros/para/areasPatrimoniais/Cadastro'
import ResgateAforamento from '@/screens/central/cadastros/para/resgateAforamento/Cadastro'
import TransferenciaDireito from '@/screens/central/cadastros/para/transferenciaDireito/Cadastro'
import Permuta from '@/screens/central/cadastros/para/permuta/Cadastro'

// TRANSFERENCIA DE DIREITO
import CadastranteTransferenciaDireito from '@/screens/central/cadastros/para/transferenciaDireito/components/Cadastrante'
import InteressadoTransferenciaDireito from '@/screens/central/cadastros/para/transferenciaDireito/components/Interessado'
import ImovelTransferenciaDireito from '@/screens/central/cadastros/para/transferenciaDireito/components/Imovel'
import ResumoTransferenciaDireito from '@/screens/central/cadastros/para/transferenciaDireito/components/Resumo'

// SOLICITAR INFORMAÇÔES
import InformacaoDesejada from '@/screens/central/cadastros/para/solicitarInformacao/components/InformacaoDesejada'
import CadastranteSolicitarInformacao from '@/screens/central/cadastros/para/solicitarInformacao/components/Cadastrante'
import InteressadoSolicitarInformacao from '@/screens/central/cadastros/para/solicitarInformacao/components/Interessado'
import ImovelSolicitarInformacao from '@/screens/central/cadastros/para/solicitarInformacao/components/Imovel'
import ResumoInformacao from '@/screens/central/cadastros/para/solicitarInformacao/components/Resumo'

// ÁREAS PATRIMONIAIS
import CadastranteAreasPatrimoniais from '@/screens/central/cadastros/para/areasPatrimoniais/components/Cadastrante'
import InteressadoAreasPatrimoniais from '@/screens/central/cadastros/para/areasPatrimoniais/components/Interessado'
import ResumoAreasPatrimoniais from '@/screens/central/cadastros/para/areasPatrimoniais/components/Resumo'

// RESGATE DE AFORAMENTO
import CadastranteResgateAforamento from '@/screens/central/cadastros/para/resgateAforamento/components/Cadastrante'
import InteressadoResgateAforamento from '@/screens/central/cadastros/para/resgateAforamento/components/Interessado'
import ImovelResgateAforamento from '@/screens/central/cadastros/para/resgateAforamento/components/Imovel'
import ResumoResgateAforamento from '@/screens/central/cadastros/para/resgateAforamento/components/Resumo'

// PERMUTA
import QualificacaoPermuta from '@/screens/central/cadastros/para/permuta/components/Qualificacao'
import CadastrantePermuta from '@/screens/central/cadastros/para/permuta/components/Cadastrante'
import InteressadoPermuta from '@/screens/central/cadastros/para/permuta/components/Interessado'
import ImovelPermuta from '@/screens/central/cadastros/para/permuta/components/Imovel'
import ResumoPermuta from '@/screens/central/cadastros/para/permuta/components/Resumo'

// GEORREFERENCIAMENTO
import AppGeorreferenciamento from '@/screens/central/components/cadastro/AppGeorreferenciamento'

const setRouteGroup = group => {
  return { routeGroup: group }
}

const perfisCentral = [PERFIL.CENTRAL_DO_INTERESSADO.EXTERNO.codigo, PERFIL.CENTRAL_DO_INTERESSADO.PREFEITURA.codigo]

/*
 * As rotas devem serguir o padrão usado no ROUTER da aplicação, pois serão incorporadas ao mesmo.
 */
export const routes = {
  CADASTROS: [
    {
      path: 'listagem/informacoes',
      name: 'listagem/informacoes',
      component: ListagemInformacao,
      meta: {
        menu: 'listagem/informacoes',
        perfis: perfisCentral,
        ...setRouteGroup('CENTRAL_SOLICITAR_INFORMACOES')
      }
    },
    {
      path: 'cadastro/informacoes/new',
      name: 'cadastro/informacoes/new',
      component: SolicitarInformacao,
      props: true,
      redirect: { name: 'informacoes/informacaoDesejada' }
    },
    {
      path: 'cadastro/informacoes/:idCadastro',
      name: 'cadastro/informacoes',
      component: SolicitarInformacao,
      props: true,
      redirect: { name: 'informacoes/informacaoDesejada' },
      children: [
        {
          path: 'informacaoDesejada',
          name: 'informacoes/informacaoDesejada',
          component: InformacaoDesejada,
          meta: {
            // Deve ser usado para casos de páginas do cadastro que não devem ser um das abas
            isIntro: true,
            perfis: perfisCentral,
            ...setRouteGroup('CENTRAL_SOLICITAR_INFORMACOES')
          }
        },
        {
          path: 'cadastrante',
          name: 'informacoes/cadastrante',
          component: CadastranteSolicitarInformacao,
          meta: {
            perfis: perfisCentral,
            ...setRouteGroup('CENTRAL_SOLICITAR_INFORMACOES')
          }
        },
        {
          path: 'interessado',
          name: 'informacoes/interessado',
          component: InteressadoSolicitarInformacao,
          meta: {
            perfis: perfisCentral,
            ...setRouteGroup('CENTRAL_SOLICITAR_INFORMACOES')
          }
        },
        {
          path: 'imovel',
          name: 'informacoes/imovel',
          component: ImovelSolicitarInformacao,
          meta: {
            perfis: perfisCentral,
            ...setRouteGroup('CENTRAL_SOLICITAR_INFORMACOES')
          }
        },
        {
          path: 'resumo',
          name: 'informacoes/resumo',
          component: ResumoInformacao,
          meta: {
            // Deve ser usado para casos de páginas do cadastro que não devem ser um das abas
            isResumo: true,
            perfis: perfisCentral,
            ...setRouteGroup('CENTRAL_SOLICITAR_INFORMACOES')
          }
        }
      ]
    },
    {
      path: 'listagem/areasPatrimoniais',
      name: 'listagem/areasPatrimoniais',
      component: ListagemAreasPatrimoniais,
      meta: {
        perfis: perfisCentral,
        ...setRouteGroup('CENTRAL_AREAS_PATRIMONIAIS')
      }
    },
    {
      path: 'cadastro/areasPatrimoniais/new',
      name: 'cadastro/areasPatrimoniais/new',
      component: AreasPatrimoniais,
      props: true,
      redirect: { name: 'areasPatrimoniais/cadastrante' }
    },
    {
      path: 'cadastro/areasPatrimoniais/:idCadastro',
      name: 'cadastro/areasPatrimoniais',
      component: AreasPatrimoniais,
      props: true,
      redirect: { name: 'areasPatrimoniais/cadastrante' },
      children: [
        {
          path: 'cadastrante',
          name: 'areasPatrimoniais/cadastrante',
          component: CadastranteAreasPatrimoniais,
          meta: {
            perfis: perfisCentral,
            ...setRouteGroup('CENTRAL_AREAS_PATRIMONIAIS')
          }
        },
        {
          path: 'interessado',
          name: 'areasPatrimoniais/interessado',
          component: InteressadoAreasPatrimoniais,
          meta: {
            perfis: perfisCentral,
            ...setRouteGroup('CENTRAL_AREAS_PATRIMONIAIS')
          }
        },
        {
          path: 'georreferenciamento',
          name: 'areasPatrimoniais/georreferenciamento',
          component: AppGeorreferenciamento,
          props: {
            // Prop usada para georreferenciamentos em que os documentos não são obrigatórios
            docsNotRequired: true,
            showGeorreferenciamentoOption: true
          },
          meta: {
            perfis: perfisCentral,
            ...setRouteGroup('CENTRAL_AREAS_PATRIMONIAIS')
          }
        },
        {
          path: 'resumo',
          name: 'areasPatrimoniais/resumo',
          component: ResumoAreasPatrimoniais,
          meta: {
            // Deve ser usado para casos de páginas do cadastro que não devem ser um das abas
            isResumo: true,
            perfis: perfisCentral,
            ...setRouteGroup('CENTRAL_AREAS_PATRIMONIAIS')
          }
        }
      ]
    },
    {
      path: 'listagem/transferenciaDireito',
      name: 'listagem/transferenciaDireito',
      component: ListagemTransferenciaDireito,
      meta: {
        perfis: perfisCentral,
        ...setRouteGroup('CENTRAL_TRANFERENCIA_DIREITO')
      }
    },
    {
      path: 'cadastro/transferenciaDireito/new',
      name: 'cadastro/transferenciaDireito/new',
      component: TransferenciaDireito,
      props: true,
      redirect: { name: 'transferenciaDireito/cadastrante' }
    },
    {
      path: 'cadastro/transferenciaDireito/:idCadastro',
      name: 'cadastro/transferenciaDireito',
      component: TransferenciaDireito,
      props: true,
      redirect: { name: 'transferenciaDireito/cadastrante' },
      children: [
        {
          path: 'cadastrante',
          name: 'transferenciaDireito/cadastrante',
          component: CadastranteTransferenciaDireito,
          meta: {
            perfis: perfisCentral,
            ...setRouteGroup('CENTRAL_TRANFERENCIA_DIREITO')
          }
        },
        {
          path: 'interessado',
          name: 'transferenciaDireito/interessado',
          component: InteressadoTransferenciaDireito,
          meta: {
            perfis: perfisCentral,
            ...setRouteGroup('CENTRAL_TRANFERENCIA_DIREITO')
          }
        },
        {
          path: 'imovel',
          name: 'transferenciaDireito/imovel',
          component: ImovelTransferenciaDireito,
          meta: {
            perfis: perfisCentral,
            ...setRouteGroup('CENTRAL_TRANFERENCIA_DIREITO')
          }
        },
        {
          path: 'georreferenciamento',
          name: 'transferenciaDireito/georreferenciamento',
          component: AppGeorreferenciamento,
          meta: {
            perfis: perfisCentral,
            ...setRouteGroup('CENTRAL_TRANFERENCIA_DIREITO')
          }
        },
        {
          path: 'resumo',
          name: 'transferenciaDireito/resumo',
          component: ResumoTransferenciaDireito,
          meta: {
            // Deve ser usado para casos de páginas do cadastro que não devem ser um das abas
            isResumo: true,
            perfis: perfisCentral,
            ...setRouteGroup('CENTRAL_TRANFERENCIA_DIREITO')
          }
        }
      ]
    },
    {
      path: 'listagem/aforamento',
      name: 'listagem/aforamento',
      component: ListagemAforamento,
      meta: {
        menu: 'listagem/aforamento',
        perfis: perfisCentral,
        ...setRouteGroup('CENTRAL_AFORAMENTO')
      }
    },
    {
      path: 'cadastro/aforamento/new',
      name: 'cadastro/aforamento/new',
      component: ResgateAforamento,
      props: true,
      redirect: { name: 'aforamento/cadastrante' }
    },
    {
      path: 'cadastro/aforamento/:idCadastro',
      name: 'cadastro/aforamento',
      component: ResgateAforamento,
      props: true,
      redirect: { name: 'aforamento/cadastrante' },
      children: [
        {
          path: 'cadastrante',
          name: 'aforamento/cadastrante',
          component: CadastranteResgateAforamento,
          meta: {
            perfis: perfisCentral,
            ...setRouteGroup('CENTRAL_AFORAMENTO')
          }
        },
        {
          path: 'interessado',
          name: 'aforamento/interessado',
          component: InteressadoResgateAforamento,
          meta: {
            perfis: perfisCentral,
            ...setRouteGroup('CENTRAL_AFORAMENTO')
          }
        },
        {
          path: 'imovel',
          name: 'aforamento/imovel',
          component: ImovelResgateAforamento,
          meta: {
            perfis: perfisCentral,
            ...setRouteGroup('CENTRAL_AFORAMENTO')
          }
        },
        {
          path: 'georreferenciamento',
          name: 'aforamento/georreferenciamento',
          component: AppGeorreferenciamento,
          meta: {
            perfis: perfisCentral,
            ...setRouteGroup('CENTRAL_AFORAMENTO')
          }
        },
        {
          path: 'resumo',
          name: 'aforamento/resumo',
          component: ResumoResgateAforamento,
          meta: {
            // Deve ser usado para casos de páginas do cadastro que não devem ser um das abas
            isResumo: true,
            perfis: perfisCentral,
            ...setRouteGroup('CENTRAL_AFORAMENTO')
          }
        }
      ]
    },
    {
      path: 'listagem/permuta',
      name: 'listagem/permuta',
      component: ListagemPermuta,
      meta: {
        menu: 'listagem/permuta',
        perfis: perfisCentral,
        ...setRouteGroup('CENTRAL_PERMUTA')
      }
    },
    {
      path: 'cadastro/permuta/new',
      name: 'cadastro/permuta/new',
      component: Permuta,
      props: true,
      redirect: { name: 'permuta/qualificacao' }
    },
    {
      path: 'cadastro/permuta/:idCadastro',
      name: 'cadastro/permuta',
      component: Permuta,
      props: true,
      redirect: { name: 'permuta/qualificacao' },
      children: [
        {
          path: 'qualificacao',
          name: 'permuta/qualificacao',
          component: QualificacaoPermuta,
          meta: {
            // Deve ser usado para casos de páginas do cadastro que não devem ser um das abas
            isIntro: true,
            perfis: perfisCentral,
            ...setRouteGroup('CENTRAL_PERMUTA')
          }
        },
        {
          path: 'cadastrante',
          name: 'permuta/cadastrante',
          component: CadastrantePermuta,
          meta: {
            perfis: perfisCentral,
            ...setRouteGroup('CENTRAL_PERMUTA')
          }
        },
        {
          path: 'interessado',
          name: 'permuta/interessado',
          component: InteressadoPermuta,
          meta: {
            perfis: perfisCentral,
            ...setRouteGroup('CENTRAL_PERMUTA')
          }
        },
        {
          path: 'imovel',
          name: 'permuta/imovel',
          component: ImovelPermuta,
          meta: {
            perfis: perfisCentral,
            ...setRouteGroup('CENTRAL_PERMUTA')
          }
        },
        {
          path: 'georreferenciamento',
          name: 'permuta/georreferenciamento',
          component: AppGeorreferenciamento,
          meta: {
            perfis: perfisCentral,
            ...setRouteGroup('CENTRAL_PERMUTA')
          }
        },
        {
          path: 'resumo',
          name: 'permuta/resumo',
          component: ResumoPermuta,
          meta: {
            isResumo: true,
            perfis: perfisCentral,
            ...setRouteGroup('CENTRAL_PERMUTA')
          }
        }
      ]
    }
  ]
}



// WEBPACK FOOTER //
// ./src/router/routes-ba/index.js